<template>
    <div
        :class="{ selected: selected }"
        class="kfitem"
    >
        <v-popconfirm
            ref="editKFDialog"
            :use-arrow="false"
            :loading="loading"
            @confirm="change"
            placement="bottom-end"
        >
            <wxkf-editor
                ref="wxkfItemEditor"
                :value="value"
            />
            <span slot="confirm-text">保存</span>
        </v-popconfirm>
        <v-popconfirm
            ref="removeConfirm"
            :use-arrow="false"
            :gap="20"
            :loading="loading"
            @confirm="remove"
            clazz="remove-wxkf"
            status="warning"
            placement="bottom-end"
        >
            <div>
                删除客服形象?
            </div>
            <span slot="confirm-text">删除</span>
        </v-popconfirm>
        <v-tip
            ref="inuse"
            placement="top"
        >
            <span>{{ deleteTip }}</span>
        </v-tip>
        <div
            @mouseenter="$emit('mouseenter', index)"
            @mouseleave="$emit('mouseleave', index)"
            class="row"
        >
            <img
                :src="value.origin_url"
                alt=""
            >
            <span
                class="name"
            ><span>{{ value.name }}</span><span
                :title="compName"
                class="comp-name"
            >@{{ compName }}</span>
            </span>

            <div class="operate">
                <v-icon
                    v-popconfirm:editKFDialog
                    name="edit"
                    class="wxkf-icon-edit"
                />

                <v-icon
                    v-popconfirm:removeConfirm
                    v-if="isDeleteEnable"
                    class="wxkf-icon-delete"
                    name="delete"
                />
                <v-icon
                    v-tip:inuse
                    v-else
                    class="wxkf-icon-delete gray"
                    name="delete"
                />
            </div>
        </div>
    </div>
</template>
<script>
import WxkfEditor from '../wxkf-editor';
import wxkfmixins from '../wxkfmixins';

export default {
    name: 'WxkfItem',
    components: {
        WxkfEditor,
    },
    mixins: [wxkfmixins],
    props: ['value', 'index', 'compName', 'canDelete', 'selected'],
    data() {
        return {
            loading: false,
        };
    },
    computed: {
        deleteTip() {
            return this.canDelete ? '使用中' : '请保留一个客服形象';
        },
        isDeleteEnable() {
            return !this.value.in_use && this.canDelete;
        },
    },
    methods: {
        change(e) {
            e.preventDefault();
            this.$refs.wxkfItemEditor
                .validate()
                .then(data => data)
                .then((data) => {
                    if (data.originUrl === this.value.origin_url && data.name === this.value.name) {
                        // 没有修改
                        this.$refs.editKFDialog.hide();
                        return;
                    }
                    let defer;
                    if (data.originUrl === this.value.origin_url) {
                        // 没有修改图片
                        defer = Promise.resolve({
                            open_kfid: this.value.open_kfid,
                            origin_url: data.originUrl,
                            name: data.name,
                        });
                    } else {
                        defer = this.uploadWx(data.originUrl).then((mediaId) => {
                            if (!mediaId) {
                                return '';
                            }
                            const postdata = {
                                open_kfid: this.value.open_kfid,
                                origin_url: data.originUrl,
                                name: data.name,
                                media_id: mediaId,
                            };
                            return postdata;
                        });
                    }
                    this.loading = true;
                    defer
                        .then((postdata) => {
                            this.$ajax
                                .gatewayPost('/v1/kf/reception/receptionConf/wechatSvr/wxAccountImage/update', postdata)
                                .then((res) => {
                                    this.loading = false;
                                    if (res.code === 0) {
                                        this.$message.success('修改客服成功');
                                        this.$refs.editKFDialog.hide();
                                        const newData = { ...postdata, in_use: this.value.in_use };
                                        this.$emit('change', this.index, newData);
                                    } else {
                                        this.$message.error(res.msg || '修改客服失败');
                                    }
                                })
                                .catch((error) => {
                                    this.loading = false;
                                    this.$message.error(error.msg || '修改客服失败');
                                });
                        })
                        .catch(() => {
                            this.loading = false;
                            this.$message.error('上传微信失败');
                        });
                })
                .catch((err) => {
                    if (err) this.$message.error(err);
                });
        },
        remove(e) {
            e.preventDefault();
            this.loading = true;
            this.$ajax
                .gatewayPost('/v1/kf/reception/receptionConf/wechatSvr/wxAccountImage/delete', {
                    open_kfid: this.value.open_kfid,
                })
                .then(
                    (res) => {
                        this.loading = false;
                        if (res.code === 0) {
                            this.$emit('remove', this.index);
                            this.$message.success('删除成功');
                        } else {
                            this.$message.error(res.msg);
                        }
                    },
                    (err) => {
                        this.loading = false;
                        this.$message.error(err.msg);
                    }
                )
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
        },
    },
};
</script>
<style lang="less">
@import '~src/common/common.less';
.remove-wxkf {
    width: 300px;
}
.kfitem {
    padding-left: 10px;
    &.selected {
        background: #f5fafe;
    }
    .row {
        height: 70px;
        line-height: 70px;
        margin: 2px 0;
        display: flex;
        align-items: center;
        img {
            width: 50px;
            height: 50px;
            vertical-align: middle;
            border-radius: 5px;
            margin-right: 16px;
        }
        .name {
            flex: 1 1 0;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .operate {
            float: right;
            padding-right: 20px;
            // display: none;
            svg {
                cursor: pointer;
                width: 14px;
                height: 19px;
                position: relative;
                top: 3px;
            }
            .wxkf-icon-delete {
                margin-left: 10px;
            }
        }
        &:hover .operate {
            display: block;
        }
        .comp-name {
            color: @AidOrg;
            padding-left: 5px;
            font-size: 14px;
            vertical-align: 2px;
        }
    }
}
</style>
